import { getContext, takeLatest, call, put } from "redux-saga/effects";
import {
  ACCOUNT_CREATE_REQUESTED,
  ACCOUNT_CREATED,
  ACCOUNT_SWITCH_REQUESTED,
  accountSwitched,
  accountCreated,
  patterns,
  reject,
  resolve,
  send,
  requestSwitchAccount
} from "actions/accounts";
import { reportError } from "helpers/error-reporting";
import { showToast } from "actions/toaster";
import { scrapeLoginToAccountId } from "utils/url";
import { SYNC_AFTER_LOGIN } from "constants/actionTypes";
import { promisaga } from "utils/as-promised";

export function* fetchAccounts() {
  try {
    yield put(send());
    const api = yield getContext("accounts");
    const accounts = yield call(api.getAccounts);
    yield put(resolve(accounts));
  } catch (error) {
    yield put(reject(error));
    yield call(reportError, error);
  }
}

export function* createAccount() {
  try {
    const accounts = yield getContext("accounts");
    const id = yield call(accounts.create);
    yield put(accountCreated(id));
  } catch (e) {
    yield put(
      showToast({ message: "Failed to create new acocunt", type: "error" })
    );
    yield call(reportError, e);
  }
}

export function* switchAccount({ payload: { id } }) {
  try {
    const auth = yield getContext("auth");
    const accounts = yield getContext("accounts");
    const accountId = yield call(auth.getAccountId);
    if (id !== accountId) {
      yield call(auth.switchAccount, id);
      yield call(accounts.approveAdd);
      yield put(accountSwitched());
    }
  } catch (e) {
    yield put(
      showToast({ message: `Failed to switch to account ${id}`, type: "error" })
    );
    yield call(reportError, e);
  }
}

export function* initialize() {
  const loginToAccountId = scrapeLoginToAccountId();
  if (loginToAccountId) {
    // if the user requested to log into a different account than the one
    // they have a token for, request a switch on their behalf
    yield call(switchAccount, requestSwitchAccount(loginToAccountId));
  }
}

export default function* saga() {
  yield takeLatest(
    [patterns.callApi, SYNC_AFTER_LOGIN, ACCOUNT_CREATED],
    fetchAccounts
  );
  yield takeLatest(ACCOUNT_CREATE_REQUESTED, promisaga(createAccount));
  yield takeLatest(
    [ACCOUNT_SWITCH_REQUESTED, ACCOUNT_CREATED],
    promisaga(switchAccount)
  );
}
